// Mock data para LUCARS website - VERSIÓN 3 (Ciudad futurista blanca y limpia)

export const siteInfo = {
  name: "LUCARS",
  tagline: "SIEMPRE EN MOVIMIENTO",
  phone: "+52 999 654 0317",
  email: "contacto@lucars.com.mx",
  instagram: "lucarsmid2021",
  instagramUrl: "https://instagram.com/lucarsmid2021"
};

export const heroData = {
  title: "LUCARS",
  subtitle: "SIEMPRE EN MOVIMIENTO",
  description: "Estrena Auto Nuevo y Genera Ingresos a través de Plataformas Tecnológicas.",
  image: "https://images.unsplash.com/photo-1760426869679-fd72a83b0f65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjaXR5JTIwYnVpbGRpbmdzJTIwbmlnaHR8ZW58MHx8fHwxNzcxMzUwNzI1fDA&ixlib=rb-4.1.0&q=85",
  cta: "Conocer más"
};

export const aboutData = {
  title: "¿Quiénes Somos?",
  description: "Somos una empresa mexicana con operaciones en la Península de Yucatán, enfocada en brindar soluciones de movilidad que impulsan el crecimiento personal y la generación de ingresos.",
  description2: "A través de autos a gasolina y eléctricos, y en colaboración con plataformas tecnológicas, ayudamos a que más personas estrenen un auto nuevo mientras construyen un futuro financiero más estable.",
  description3: "En Lucars, creemos que la movilidad no solo conecta destinos, sino que abre oportunidades, genera independencia y transforma vidas.",
  valueProposition: "Nuestros clientes generan sus propios ingresos sin preocuparse por los gastos adicionales que implica un automóvil. Al término del plazo estipulado en el contrato, tienen la posibilidad de adquirir su propio auto, consolidando así su esfuerzo y construyendo patrimonio.",
  imageElectric: "https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b",
  imageGasoline: "https://images.unsplash.com/photo-1709719263439-364363375a3a",
  stats: [
    { number: "2021", label: "Año de Fundación" },
    { number: "UBER, DIDI & InDriver", label: "Alianzas" },
    { number: "Yucatán", label: "Península de Yucatán" },
    { number: "Campeche", label: "Próximamente" }
  ]
};

export const howWeDoItData = {
  title: "¿Cómo lo Hacemos?",
  description: "Nuestro proceso se basa en 5 puntos",
  steps: [
    {
      number: "1",
      title: "Revisamos tus Documentos",
      description: "Analizamos tu información y documentación para iniciar el proceso.",
      icon: "ClipboardCheck"
    },
    {
      number: "2",
      title: "Escoge tu Nuevo Auto",
      description: "Selecciona el vehículo que mejor se adapte a tus necesidades.",
      icon: "Car"
    },
    {
      number: "3",
      title: "Preparamos Documentación",
      description: "Nos encargamos de toda la gestión legal y administrativa.",
      icon: "FileText"
    },
    {
      number: "4",
      title: "Estrena y Genera Ingresos",
      description: "Comienza a trabajar y generar tus propios ingresos desde el día uno.",
      icon: "TrendingUp"
    },
    {
      number: "5",
      title: "Adquiere tu Auto",
      description: "Al finalizar el contrato, el vehículo puede ser tuyo.",
      icon: "Key"
    }
  ]
};

export const whyChooseUsData = {
  title: "¿Por Qué Elegirnos?",
  description: "Queremos ser parte de tu historia.\n\nSabemos lo difícil que es generar ingresos por cuenta propia, por eso apoyamos otorgando una herramienta de trabajo que te permita hacerlo de forma adecuada, brindando soluciones de movilidad que, al mismo tiempo, ayudan a que más personas disfruten viajes cómodos, seguros y, en algunos casos, más amigables con el medio ambiente.\n\nEn Lucars nos enfocamos en cada persona. Nos gusta conocer la historia de cada uno de nuestros clientes, porque no queremos ser solo una opción más; queremos convertirnos en una pequeña parte de su éxito.\n\nEn esta ocasión, tú marcas el camino.\nNosotros te brindamos la solución.\nLo demás corre por tu cuenta.\n\n\"Si trabajas en lo que te gusta, no trabajarás ni un día.\""
};

export const contactData = {
  title: "Contacto",
  description: "¿Listo para generar ingresos con LUCARS? Contáctanos y comienza tu camino hacia la independencia financiera.",
  phone: "+52 999 654 0317",
  email: "contacto@lucars.com.mx",
  instagram: "lucarsmid2021",
  address: "Mérida, Yucatán, México"
};
